import { useTheme } from 'styled-components';
import Text from '../../../../ToolkitV2/Text/Text';
import * as Styled from './TrustedDealerPanel.styled';
import { TrustedDealerPanelProps } from './TrustedDealerPanel.typed';
import { plural } from '@dist-marketplace-frontend/utils';
import { Link } from '../../../../Toolkit/Button/Link';
import { ShieldCheckmark2Ic, StarIc } from '@dsch/dd-icons';

const TrustedDealerPanel = (props: TrustedDealerPanelProps) => {
  const theme = useTheme();
  const {
    dealer,
    className,
    onClickTDPSubtitle,
    onClickRatings,
    onClickBusinessType,
    dataTestid,
  } = props;

  const businessType = dealer.businessType || 'N/A';
  const rating = dealer.googleReview?.rating || 0;
  const reviewCount = parseInt(dealer.googleReview?.userRatingsTotal ?? '0');
  const hasReviews = reviewCount > 0;
  const membershipDuration = dealer.membershipDuration || 'N/A';

  return (
    <Styled.STrustedDealerPanel className={className} data-testid={dataTestid}>
      <Styled.TDPInfo>
        <ShieldCheckmark2Ic width="40" height="40" color={theme.colors.GREEN} />
        <Styled.TDPDescription>
          <Text size={'L18'} weight={'bold'} color={'GREY_DARKER'}>
            Trusted Dealer
          </Text>
          <Link
            fontSize="B14"
            ofType={'SECONDARY'}
            underline
            onClick={onClickTDPSubtitle}
          >
            Certified by DoneDeal
          </Link>
        </Styled.TDPDescription>
      </Styled.TDPInfo>

      <Styled.DealerInfo>
        <Styled.InfoSection>
          <Styled.Rating onClick={onClickRatings} name="rating">
            {hasReviews ? (
              <>
                {rating}/5{' '}
                <StarIc color={theme.colors.ORANGE} width="16" height="16" />
              </>
            ) : (
              <StarIc color={theme.colors.GREY_DARK} width="16" height="16" />
            )}
          </Styled.Rating>
          <Styled.Subtitle>
            {hasReviews
              ? `${reviewCount} ${plural('Review', 'Reviews', reviewCount)}`
              : 'No reviews yet'}
          </Styled.Subtitle>
        </Styled.InfoSection>

        <Styled.Divider />

        <Styled.InfoSection>
          <Styled.Rating
            onClick={onClickBusinessType}
            name="business-type"
            aria-label={`Open business type information modal`}
          >
            {businessType}
          </Styled.Rating>
          <Styled.Subtitle>Business</Styled.Subtitle>
        </Styled.InfoSection>

        <Styled.Divider />

        <Styled.InfoSection>
          <Text size="M14" color="GREY_DARKER" weight="bold">
            {membershipDuration}
          </Text>
          <Styled.Subtitle>On DoneDeal</Styled.Subtitle>
        </Styled.InfoSection>
      </Styled.DealerInfo>
    </Styled.STrustedDealerPanel>
  );
};

export { TrustedDealerPanel };
